import { render, staticRenderFns } from "./NpRecognitionList.vue?vue&type=template&id=52e286b2&scoped=true"
import script from "./NpRecognitionList.vue?vue&type=script&lang=js"
export * from "./NpRecognitionList.vue?vue&type=script&lang=js"
import style0 from "./NpRecognitionList.vue?vue&type=style&index=0&id=52e286b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e286b2",
  null
  
)

export default component.exports